// This file is auto-generated during build from package.json
// Do not edit manually - changes will be overwritten
export const VERSION = '4.6.7';
export const BUILD_NUMBER = 3;
export const VERSION_WITH_BUILD = '4.6.7 (build 3)';
